// extracted by mini-css-extract-plugin
export default {"dot":"ComplexityDot_dot__jX0AN","easy":"ComplexityDot_easy__U1f9X","medium":"ComplexityDot_medium__AL0+E","hard":"ComplexityDot_hard__QbW9a"};